import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InstallComponent } from './view/install/install.component';

const routes : Routes = [
	{
		path: '',
		redirectTo: 'guide/install',
		pathMatch: 'full'
	},
	{
		path: 'guide/install',
		component: InstallComponent
	},
	{
		path: 'guide/start',
		loadChildren: './view/start/start.module#ButtonModule'
	},
	{
		path: 'component/button',
		loadChildren: './view/button/buttonDemo.module#ButtonDemoModule'
	},
	{
		path: 'component/splitButton',
		loadChildren: './view/splitButton/splitButtonDemo.module#SplitButtonDemoModule'
	},
	{
		path: 'component/selectButton',
		loadChildren: './view/selectButton/selectButtonDemo.module#SelectButtonDemoModule'
	},
	{
		path: 'component/radioButton',
		loadChildren: './view/radioButton/radioButtonDemo.module#RadioButtonDemoModule'
	},
	{
		path: 'component/dropdown',
		loadChildren: './view/dropDown/dropDownDemo.module#DropDownDemoModule'
	},
	{
		path: 'component/inputgroup',
		loadChildren: './view/inputGroup/inputGroupDemo.module#InputGroupDemoModule'
	},
	{
		path: 'component/checkbox',
		loadChildren: './view/checkbox/checkboxDemo.module#CheckboxDemoModule'
	},
	{
		path: 'component/switch',
		loadChildren: './view/switch/switchDemo.module#SwitchDemoModule'
	},
	{
		path: 'component/password',
		loadChildren: './view/password/passwordDemo.module#PasswordDemoModule'
	},
	{
		path: 'component/card',
		loadChildren: './view/card/cardDemo.module#CardDemoModule'
	},
	{
		path: 'component/tabs',
		loadChildren: './view/tabsview/tabsviewDemo.module#TabsviewDemoModule'
	},
	{
		path: 'component/confirm',
		loadChildren: './view/confirmdialog/confirmdialogDemo.module#ConfirmdialogDemoModule'
	},
	{
		path: 'component/dialog',
		loadChildren: './view/dialog/dialogDemo.module#DialogDemoModule'
	},
	{
		path: 'component/sidebar',
		loadChildren: './view/sidebar/sidebarDemo.module#SidebarDemoModule'
	},
	{
		path: 'component/tooltip',
		loadChildren: './view/tooltip/tooltipDemo.module#TooltipDemoModule'
	},
	{
		path: 'component/fileupload',
		loadChildren: './view/fileupload/fileuploadDemo.module#FileuploadDemoModule'
	},
	{
		path: 'component/steps',
		loadChildren: './view/steps/stepsDemo.module#StepsDemoModule'
	},
	{
		path: 'component/panelmenu',
		loadChildren: './view/panelmenu/panelmenuDemo.module#PanelmenuDemoModule'
	},
	{
		path: 'component/breadcrumb',
		loadChildren: './view/breadcrumb/breadcrumbDemo.module#BreadcrumbDemoModule'
	},
	{
		path: 'component/messages',
		loadChildren: './view/messages/messagesDemo.module#MessagesDemoModule'
	},
	{
		path: 'component/growl',
		loadChildren: './view/growl/growlDemo.module#GrowlDemoModule'
	},
	{
		path: 'component/table',
		loadChildren: './view/table/tableDemo.module#TableDemoModule'
	},
	{
		path: 'component/grid',
		loadChildren: './view/grid/grid.module#GridModule'
	}
]

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts